import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  BulkSend({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/bulk_sms_delayed",
        data: data,
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  BulkHistory({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/bulk_sms/list",
        params: {
          page: list.page,
          per_page: list.per_page ? list.per_page : '',
          order_by: list.order_by,
          order_dir: list.order_dir,
        },
        method: "GET",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  BulkRun({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/bulk_sms/" + uuid + "/run",
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  BulkHold({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/bulk_sms/" + uuid + "/hold",
        method: "POST",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
